export interface FileRow {
  id: string;
  fileName: string;
  size: string;
  createdAt: string;
  fileType: string;
}

export interface FileWithId {
  id: string;
  createdAt: string;
  content?: Partial<File>;
}

export enum ActionsRowCta {
  DELETE = "delete",
  VIEW = "view",
  DOWNLOAD = "download",
}

export interface FetchedFile {
  Owner: {
    name: string;
    id: string;
    email: string;
  };
  payload?: Record<string, any>;
  File_Name: string;
  Created_Time: string;
  Size: string;
  id: string;
}

export interface FetchedFileList {
  list: FetchedFile[];
  total: number;
}

export interface UploadFileData {
  code: string;
  details: {
    name: string;
    id: string;
  };
  message: string;
  status: string;
}
